import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate } from "react-router-dom";
import "./MatchList.css";

const MatchList = () => {
  const [matches, setMatches] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchMatches();
    const interval = setInterval(fetchMatches, 1000);
    return () => clearInterval(interval);
  }, []);

  async function fetchMatches() {
    try {
      const snapshot = await getDocs(collection(db, "matches"));
      const now = new Date();
      const today = now.toISOString().split("T")[0];

      const list = snapshot.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .filter(match => {
          if (!match.matchDate) return false;
          if (match.matchDate !== today) return false;

          const start = new Date(`${match.matchDate}T${match.matchTime}`);
          const diff = (start - now) / 60000;
          return diff > -30;
        });

      setMatches(list);
    } catch (err) {
      console.error("MATCH ERROR:", err);
    }
  }

  const renderCountdown = (match) => {
    const now = new Date();
    const start = new Date(`${match.matchDate}T${match.matchTime}`);
    const diffMs = start - now;

    if (diffMs <= 0) return "Started";

    const sec = Math.floor(diffMs / 1000);
    const h = String(Math.floor(sec / 3600)).padStart(2, "0");
    const m = String(Math.floor((sec % 3600) / 60)).padStart(2, "0");
    const s = String(sec % 60).padStart(2, "0");

    return `${h}:${m}:${s};`
  };

  return (
    <div className="match-list-container">

      {matches.length === 0 && (
        <p className="no-matches">waiting</p>
      )}

      {matches.map((match, i) => (
        <div
          key={match.id}
          className={`match-card ${i % 2 === 0 ? "bg-red" : "bg-blue"}`}
          onClick={() =>
            navigate("/eventlist", {
              state: {
                match,
                autoBet: {
                  score: match.ok?.score || 0,
                  odds: match.ok?.odds || 1.5,
                  teamA: match.teamA,
                  teamB: match.teamB,
                  matchId: match.id
                }
              }
            })
          }
        >
          <div className="match-amount">
         
          </div>

          <div className="match-details">
            <div className="match-date">{match.matchDate} {match.matchTime}</div>
            <div className="match-teams">{match.teamA} VS {match.teamB}</div>

            {match.ok && (
              <div className="match-score">
                score {match.ok.score} odds
                <span className="match-odds">{Number(match.ok.odds).toFixed(2)}%</span>
              </div>
            )}

            <div className={`match-countdown ${renderCountdown(match) === "Started" ? "started" : ""}`}>
              {renderCountdown(match)}
            </div>
          </div>
        </div>
      ))}

    </div>
  );
};

export default MatchList;